import { useCallback, useState, type ReactElement } from 'react'

import type { ParentScreenshotRead } from '@/client'
import { ParentScreenshotViewer } from '@/components/features/parent-screenshot-viewer'

interface ViewerRequest {
  screenshots: ParentScreenshotRead[]
  index: number
}

export function useParentScreenshotViewer(): {
  open: (screenshots: ParentScreenshotRead[], index: number) => void
  viewer: ReactElement | null
} {
  const [request, setRequest] = useState<ViewerRequest | null>(null)

  const open = useCallback((screenshots: ParentScreenshotRead[], index: number) => {
    setRequest({ screenshots, index })
  }, [])
  const close = useCallback(() => setRequest(null), [])

  const viewer = request ? (
    <ParentScreenshotViewer
      screenshots={request.screenshots}
      index={request.index}
      onClose={close}
    />
  ) : null

  return { open, viewer }
}
